import {useEffect, useRef, useState} from 'react';
import {
  AccessibilityInfo,
  Dimensions,
  findNodeHandle,
  InteractionManager,
  Keyboard,
  Platform,
  View,
} from 'react-native';

export const useBottomSheetModal = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [screenHeight, setScreenHeight] = useState(
    Dimensions.get('window').height,
  );
  const [screenWidth, setScreenWidth] = useState(
    Dimensions.get('window').width,
  );

  const closeButtonKeyboardRef = useRef<any>(null);
  const closeButtonA11yRef = useRef<View>(null);

  useEffect(() => {
    const showEvent =
      Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
    const hideEvent =
      Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';

    const showSub = Keyboard.addListener(showEvent, e => {
      setKeyboardHeight(e.endCoordinates.height);
    });

    const hideSub = Keyboard.addListener(hideEvent, () => {
      setKeyboardHeight(0);
    });

    return () => {
      showSub.remove();
      hideSub.remove();
    };
  }, []);

  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', ({window}) => {
      setScreenHeight(window.height);
      setScreenWidth(window.width);
    });

    return () => {
      subscription?.remove();
    };
  }, []);

  const focusCloseButton = () => {
    InteractionManager.runAfterInteractions(() => {
      setTimeout(
        () => {
          closeButtonKeyboardRef.current?.focus?.();

          const node = findNodeHandle(closeButtonA11yRef.current);
          if (node) {
            AccessibilityInfo.setAccessibilityFocus(node);
          }
        },
        Platform.OS === 'android' ? 300 : 150,
      );
    });
  };

  return {
    keyboardHeight,
    screenHeight,
    screenWidth,
    closeButtonKeyboardRef,
    closeButtonA11yRef,
    focusCloseButton,
  };
};
